export default class StoreModel {
  static isLoading(data: LoadedSingleResource | LoadedResource): boolean {
    return !data || data.fetching;
  }

  static isLoaded(
    data: LoadedSingleResource | LoadedResource | undefined
  ): boolean {
    if (!data) {
      return false;
    }
    return data && !data.fetching;
  }

  static isEmpty(data: LoadedSingleResource | LoadedResource): boolean {
    if (!data) {
      return true;
    }
    if (Array.isArray(data.data)) {
      return data.data.length === 0;
    }
    return data.data === null;
  }

  static isError(data: LoadedSingleResource | LoadedResource): boolean {
    if (!data) {
      return false;
    }
    return !!data.error;
  }

  static default<T>(): LoadedResource<T> {
    return {
      fetching: false,
      error: null,
      data: [],
    };
  }

  static defaultSingle<T>(): LoadedSingleResource<T> {
    return {
      fetching: false,
      error: null,
      data: null,
    };
  }

  static fetching<T>(): LoadedResource<T> {
    return {
      fetching: true,
      error: null,
      data: [],
    };
  }

  static result<T>(data: T[]): LoadedResource<T> {
    return {
      fetching: false,
      error: null,
      data: data,
    };
  }

  static error<T>(err: any): LoadedResource<T> {
    return {
      fetching: false,
      error: err,
      data: [],
    };
  }

  static fetchingSingle<T>(): LoadedSingleResource<T> {
    return {
      fetching: true,
      error: null,
      data: null,
    };
  }

  static resultSingle<T>(data: T): LoadedSingleResource<T> {
    return {
      fetching: false,
      error: null,
      data: data,
    };
  }

  static errorSingle<T>(err: any): LoadedSingleResource<T> {
    return {
      fetching: false,
      error: err,
      data: null,
    };
  }
}

export interface LoadedSingleResource<T = any> {
  fetching: boolean;
  error: any;
  data: T | null;
}

export interface LoadedResource<T = any> {
  fetching: boolean;
  error: any;
  data: T[];
}



// WEBPACK FOOTER //
// ./src/store/StoreModel.ts